// extracted by mini-css-extract-plugin
export default {"root":"AppLayout_root__dHcb7"};